import { render, staticRenderFns } from "./OrgSelect.vue?vue&type=template&id=52e37a5d"
import script from "./OrgSelect.vue?vue&type=script&lang=js"
export * from "./OrgSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports